type PilotConversionPayload = {
  eventType: 'profile_viewed' | 'claim_started'
  masjidSlug?: string
  claimId?: string
  path?: string
  metadata?: Record<string, unknown>
}

function browserId(storage: Storage, key: string, prefix: string) {
  const existing = storage.getItem(key)
  if (existing) return existing
  const value = `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 9)}`
  storage.setItem(key, value)
  return value
}

export function recordPilotClientConversion(payload: PilotConversionPayload, options: { oncePerSession?: boolean } = {}) {
  if (typeof window === 'undefined') return
  const dedupeKey = `pilot:${payload.eventType}:${payload.masjidSlug || payload.claimId || 'general'}`
  if (options.oncePerSession && sessionStorage.getItem(dedupeKey)) return
  if (options.oncePerSession) sessionStorage.setItem(dedupeKey, '1')

  const body = JSON.stringify({
    ...payload,
    path: payload.path || window.location.pathname,
    anonymousId: browserId(localStorage, 'masjids_pilot_visitor', 'visitor'),
    sessionId: browserId(sessionStorage, 'masjids_pilot_session', 'session'),
  })

  fetch('/api/pilot/conversion', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => undefined)
}
